import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '../../configs';
import { VersionDTO } from '../../models/dto/version.dto';
import { ApiService } from '../common';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  constructor(private readonly http: ApiService) {}

  getAll() {
    return this.http.get(API_ENDPOINT.version.controller);
  }

  getDetail(id: number) {
    return this.http.get(API_ENDPOINT.version.controller + id);
  }

  createVersion(data: VersionDTO) {
    const formData = new FormData();
    formData.append('startDatetime', data.startDatetime.toISOString());
    formData.append('version', data.version);
    formData.append('file', data.file);
    return this.http.postFormData(API_ENDPOINT.version.controller, formData);
  }

  updateVersion(data: VersionDTO, id: number) {
    const formData = new FormData();
    const fields = {
      file: data.file,
      startDatetime: data.startDatetime.toISOString(),
      version: data.version,
    };

    Object.entries(fields).forEach(([key, value]) => {
      if (value) {
        formData.append(key, value);
      }
    });

    return this.http.patchFormData(API_ENDPOINT.version.controller + id, formData);
  }

  deleteVersion(id: number) {
    return this.http.delete(API_ENDPOINT.version.controller + id);
  }

  getAttachment(id: number) {
    return this.http.get(API_ENDPOINT.version.controller + API_ENDPOINT.version.getAttachment + id);
  }
}
